<template>
  <el-skeleton v-bind="$attrs" animated v-on="$listeners">
    <template slot="template">
      <div>
        <el-skeleton-item
          variant="rect"
          :style="{ width, height }"
        />
      </div>
    </template>
    <slot />
  </el-skeleton>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BlockSkeleton',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  setup (props, { emit }) {
    return {}
  },
})
</script>

<style lang="postcss" scoped>

</style>
